'use client'

import { type FC, type PropsWithChildren, useMemo } from 'react'
import { useIntl } from 'react-intl'

import { LocaleContext } from 'base-ui'

export const I18nBaseUiLocaleContext: FC<PropsWithChildren> = ({
  children,
}) => {
  const intl = useIntl()

  const value = useMemo(
    () => ({
      dialog: {
        close: intl.formatMessage({
          id: 'general.link.label.close',
        }),
      },
      select: {
        close: intl.formatMessage({
          id: 'general.link.label.close',
        }),
      },
    }),
    [intl],
  )

  return <LocaleContext value={value}>{children}</LocaleContext>
}
